import React, { useEffect, useState } from "react";

import { getConfig } from "@edx/frontend-platform";
import { breakpoints } from "@openedx/paragon";
import classNames from "classnames";
import PropTypes from "prop-types";
import MediaQuery from "react-responsive";

import imgRegister from "./img/img-register.jpg";
import imgLogin from "./img/img-login.png";

import logoGetCertificate from "./img/logo-getcertificate.png";

import { useLocation } from "react-router-dom";

const BaseContainer = ({ children, showWelcomeBanner, fullName }) => {
  const enableImageLayout = getConfig().ENABLE_IMAGE_LAYOUT;
  const location = useLocation();
  const [pathData, setPathData] = useState(location.pathname);

  useEffect(() => {
    setPathData(location.pathname);
  }, [location]);

  if (enableImageLayout) {
    return (
      <div className="layout">
        <div
          className={classNames("content", {
            "align-items-center mt-0": showWelcomeBanner,
          })}
        >
          {children}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="layout authn-container">
        <div
          className={classNames("content", {
            "align-items-center mt-0": showWelcomeBanner,
          })}
        >
          <div className="img-logo">
            <a href="https://getcertificate.online">
              <img src={logoGetCertificate} alt="" />
            </a>
          </div>
          {children}
        </div>

        {pathData == "/login" ? (
          <div className="layout-image">
            <img src={imgLogin} alt="" />
          </div>
        ) : (
          <>
            <div className="layout-image layout-extended">
              <img src={imgRegister} alt="" />
            </div>
          </>
        )}
      </div>
      <div className="getcertificate-logo-container">
        <a href="https://getcertificate.online">
          <img src={logoGetCertificate} alt="" />
        </a>
      </div>
    </>
  );
};

BaseContainer.defaultProps = {
  showWelcomeBanner: false,
  fullName: null,
};

BaseContainer.propTypes = {
  children: PropTypes.node.isRequired,
  showWelcomeBanner: PropTypes.bool,
  fullName: PropTypes.string,
};

export default BaseContainer;
